var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.successAlertActive)?_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-alert',{staticClass:"mt-3",attrs:{"text":"","border":"top","color":"success"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.message))])])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }